
<template>
  <div>
    <dialog-loading v-if="saving" loadingText='Salvando...'></dialog-loading>
    <v-alert dense border="left"
      :value="true" :type="status_map[economic_group_credit?.data?.attributes?.status_id || economic_group_credit?.status_id]?.type || 'info'">
      <v-row align="center">
        <div class="d-flex flex-column my-3 ml-3" > 
          <div v-if="existsBlockLogs && isBlocked">
            <div>
              <v-icon small class="mr-2" color="error">mdi-account-group</v-icon>
              <span><strong>Grupo Econômico Bloqueado</strong></span>
            </div>
            <div v-if="currentBlockLog?.comment" class="mt-1 ml-4">
              {{ currentBlockLog.comment }}
            </div>
            <div v-else class="mt-1 ml-4">
              Grupo Econômico Bloqueado
            </div>
          </div>
          <div v-if="!isBlocked"> 
            <b v-if="currentBlockLog?.block_type == 'manual'">DESBLOQUEADO MANUALMENTE</b>
            <span v-else>{{status_map[economic_group_credit?.data?.attributes?.status_id || economic_group_credit?.status_id]?.text || 'Grupo Regular'}} </span>
          </div>
          <span class="subtitle-2" v-if="!isBlocked">
            Limite restante: {{Number(economic_group_credit?.data?.attributes?.limit || economic_group_credit?.limit || 0).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
          </span> 
          <div v-if="currentBlockLog?.created_at">
            <v-divider class="my-2"></v-divider>
            <span class="caption">Última atualização: {{ $moment(currentBlockLog.created_at).format("DD/MM/YYYY [às] HH:mm") }}</span>
          </div>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex flex-column">
          <v-btn v-if="!isBlocked && canBlock && !hide_buttons" @click="submitBlock()" rounded small class="mt-3 mx-3">
            <v-icon left small>mdi-account-lock</v-icon>
            <span>Bloquear</span>
          </v-btn>
          <v-btn v-if="isBlocked && canBlock && !hide_buttons" @click="submitUnblock()" rounded small class="my-3 mx-3">
            <v-icon left small> mdi-account-lock-open</v-icon>
            <span>Desbloquear</span>
          </v-btn>
          <v-btn @click="checkEconomicGroup()" rounded small class="my-3 mx-3">
            <v-icon left small> mdi-refresh</v-icon>
            <span>Verificar bloqueios</span>
          </v-btn>
        </div>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Api from '@/api/index'

export default {
  name: 'EconomicGroupBlockAlert',
  props:{
    economic_group_credit:{
      type: Object,
      required: true
    },
    economic_group:{
      type: Object,
      required: true
    },
    hide_buttons:{
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      saving: false,
      status_map:{
        "10": { text: "Grupo Bloqueado", type:"error" },
        "18": { text: "Grupo Bloqueado", type:"error" },
        "9": { text: "Grupo com faturas atrasadas, mas ainda há tempo para quitar", type:"warning" },
        "1": { text: "Grupo Regular", type:"success" },
      }
    }
  },
  methods: {
    checkEconomicGroup(){
      this.saving = true
      // Recarrega os dados do grupo econômico
      Api.EconomicGroup.show(this.economic_group?.id || this.economic_group?.data?.id).then((res)=>{
        // Atualiza os dados do crédito localmente
        const data = res.data.data
        if (data.attributes?.economic_group_credit) {
          this.$emit("credit_updated", data.attributes.economic_group_credit)
        }
        this.$emit("credit_updated")
      }).finally(()=>{
        this.saving = false
      })
    },
    updateEconomicGroup(economic_group){
      this.saving = true
      Api.EconomicGroup.update(economic_group).then(()=>{
        this.successSaved()
        this.$emit("successSaved")
      }).catch(er => {
        this.errorUpdated()
      }).finally(()=>{
        this.saving = false
      })
    },
    submitBlock() {
      this.swallConfirmation({
          title: `Bloquear grupo econômico?`,
          text: 'Todos os clientes do grupo também serão bloqueados.',
          icon: 'question',
        }).then( confirmed =>{
          if ( confirmed ) {
            let credit = this.economic_group_credit?.data || this.economic_group_credit
            let obj = {
              id: this.economic_group?.id || this.economic_group?.data?.id,
              economic_group_credit_attributes: {
                id: credit?.id || credit?.attributes?.id,
                status_id: this.allStatuses.find(o => o.attributes.title.includes("Client blocked manually")).id,
                last_change_employee_id: this.current_user_employee_id
              }
            }
            this.updateEconomicGroup(obj)
          }
        })
    },
    submitUnblock() {
      this.swallConfirmation({
          title: `Desbloquear grupo econômico?`,
          icon: 'question',
        }).then( confirmed =>{
          if ( confirmed ) {
            let credit = this.economic_group_credit?.data || this.economic_group_credit
            let obj = {
              id: this.economic_group?.id || this.economic_group?.data?.id,
              economic_group_credit_attributes: {
                id: credit?.id || credit?.attributes?.id,
                warned_since: null,
                status_id: 1,
                last_change_employee_id: this.current_user_employee_id
              },
            }
            this.updateEconomicGroup(obj)
          }
        })
    },
  },
  computed: {
    isBlocked(){
      let statusId = this.economic_group_credit?.data?.attributes?.status_id || this.economic_group_credit?.status_id
      return statusId == "10" || statusId == "18"
    },
    existsBlockLogs(){
      let lastBlockLog = this.economic_group_credit?.data?.attributes?.last_block_log || this.economic_group_credit?.last_block_log
      return lastBlockLog && typeof lastBlockLog === 'object' && Object.keys(lastBlockLog).length > 0
    },
    currentBlockLog(){
      let lastBlockLog = this.economic_group_credit?.data?.attributes?.last_block_log || this.economic_group_credit?.last_block_log
      if (lastBlockLog && typeof lastBlockLog === 'object' && Object.keys(lastBlockLog).length > 0) {
        return lastBlockLog
      }
      return null
    },
    canBlock() {
      return this.isSalesExecutive() || this.isDirector() || this.isCreditAnalyst()
    },
    ...mapState({
      allStatuses: state => state.Status.allStatuses,
    })
  },
}
</script>
